import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import policyDocument from "./policyDocumentService";

const initialState = {
  userPolicyDocuments: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// ✅ Get All
export const getPolicyDocuments = createAsyncThunk(
  "policyDocument/getAll",
  async (params, thunkAPI) => {
    try {

      return await policyDocument.getPolicyDocuments(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPolicyDocumentByUuid = createAsyncThunk(
  "policyDocument/getByUuid",
  async (uuid, thunkAPI) => {
    try {

      return await policyDocument.getPolicyDocumentByUuid(uuid);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


// ✅ Slice
export const policyDocumentSlice = createSlice({
  name: "userPolicyDocuments",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
     
      // Get All
      .addCase(getPolicyDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.userPolicyDocuments = action.payload.data;
      })
      .addCase(getPolicyDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getPolicyDocumentByUuid.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyDocumentByUuid.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.userPolicyDocuments = action.payload.data;
      })
      .addCase(getPolicyDocumentByUuid.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
     
  },
});

export const { reset } = policyDocumentSlice.actions;
export default policyDocumentSlice.reducer;
